import { Create, SimpleForm, TextInput, useNotify } from 'react-admin';

import { formatError } from '../../utils/formatApiError';
import { BusinessLocationInputs } from './BusinessLocationInputs';

function cleanBusinessPayload(data: Record<string, unknown>) {
  const out: Record<string, unknown> = { ...data };
  for (const key of ['email', 'website_url', 'tagline', 'description', 'address_line', 'pincode', 'phone', 'whatsapp']) {
    if (out[key] === '' || out[key] === null) {
      delete out[key];
    }
  }
  if (!out.template_id) {
    delete out.template_id;
  }
  for (const key of ['category_id', 'country_id', 'state_id', 'city_id'] as const) {
    const v = out[key];
    if (v !== undefined && v !== null && v !== '') {
      out[key] = Number(v);
    }
  }
  return out;
}

export function BusinessCreate() {
  const notify = useNotify();

  return (
    <Create
      redirect="list"
      transform={cleanBusinessPayload}
      mutationOptions={{
        onError: (error) => {
          notify(formatError(error), { type: 'error', multiLine: true });
        },
      }}
    >
      <SimpleForm>
        <TextInput
          source="name"
          fullWidth
          validate={(value) => (!value ? 'Name is required' : undefined)}
        />
        <TextInput source="tagline" fullWidth />
        <TextInput source="description" fullWidth multiline rows={4} />
        <BusinessLocationInputs />
        <TextInput source="address_line" label="Address" fullWidth />
        <TextInput source="pincode" label="Pincode" />
        <TextInput source="phone" label="Phone" />
        <TextInput source="whatsapp" label="WhatsApp" />
        <TextInput source="email" label="Email" />
        <TextInput
          source="website_url"
          label="Website URL (optional)"
          fullWidth
          helperText="Leave blank if the business has no website yet."
        />
      </SimpleForm>
    </Create>
  );
}
